// extracted by mini-css-extract-plugin
module.exports = {"content":"Header_content__2CvKO","smallScreenOnly":"Header_smallScreenOnly__2Jog2"};